<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">
      Add group
    </div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <coso-select-input [control]="formGroup.controls.id" [inputText]="formText.id"></coso-select-input>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
    <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
